import { useLang } from "@/i18n";

export function Marquee() {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div data-testid="editorial-marquee" className="border-y border-[#E5E5E5] bg-[#F3EFE7] overflow-hidden py-5 select-none">
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {items.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif italic text-2xl sm:text-3xl text-[#0A0A0A] px-8 whitespace-nowrap">{item}</span>
                <span className="w-1.5 h-1.5 rotate-45 bg-[#6B1E33]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
